<app-form-field
  [label]="label"
  [required]="required"
  [optional]="optional"
  [control]="control"
  [submitted]="submitted"
  [errorMessages]="errorMessages"
  [serverError]="serverError"
  actionVerb="Select"
>
  <input
    type="date"
    class="form-control"
    [class.is-invalid]="isInvalid"
    [formControl]="formControl"
    [id]="id"
    [placeholder]="placeholder"
    [attr.min]="min"
    [attr.max]="max"
    (keydown)="keydown.emit($event)"
  />
</app-form-field>
